import { c as _c } from "react/compiler-runtime";
import { RedPriceTooltip } from '@components/red-price-tooltip/RedPriceTooltip';
import infoIcon from '@images/svg/info.svg';
import { useDeviceScreen } from '@lib/layouts/DeviceScreenProvider';
import formatLongPrice from '@lib/tools/_format-long-price';
import { SCHEMA } from '@lib/tools/helpers/constants';
import Svg from 'react-inlinesvg';
import { useSelector } from 'react-redux';
import { Tooltip } from 'react-tooltip';
import styles from './PriceBlock.module.scss';
const PriceBlock = t0 => {
  const $ = _c(17);
  const {
    flat
  } = t0;
  const {
    isMobile
  } = useDeviceScreen();
  const {
    currentData,
    selectedBenefit
  } = useSelector(_temp);
  let t1;
  if ($[0] !== currentData?.currentBenefitPrice || $[1] !== flat?.currentPrice || $[2] !== selectedBenefit?.benefitPrice || $[3] !== selectedBenefit?.group) {
    t1 = () => {
      let price = selectedBenefit?.benefitPrice ?? flat?.currentPrice;
      if (selectedBenefit?.group === "mortgage" && currentData?.currentBenefitPrice) {
        price = currentData?.currentBenefitPrice;
      }
      return price;
    };
    $[0] = currentData?.currentBenefitPrice;
    $[1] = flat?.currentPrice;
    $[2] = selectedBenefit?.benefitPrice;
    $[3] = selectedBenefit?.group;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const getFlatPrice = t1;
  let t2;
  if ($[5] !== flat?.currentPrice || $[6] !== flat?.promo || $[7] !== flat?.real_price || $[8] !== flat?.redPrice || $[9] !== getFlatPrice || $[10] !== isMobile || $[11] !== selectedBenefit?.bestPrice) {
    t2 = flat?.promo ? <RedPriceTooltip text={"\u0410\u043A\u0446\u0438\u044F, \u0441\u0443\u043C\u043C\u0443 \u0432\u044B\u0433\u043E\u0434\u044B  \u0443\u0442\u043E\u0447\u043D\u044F\u0439\u0442\u0435 \u0443 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0430"} someStyles={styles.tooltip}><span className={`${styles.flatDescription__amount} ${styles.flatInfoRight__price_orange}`}>{formatLongPrice(flat?.currentPrice)} ₽</span><meta itemProp="price" content={flat?.currentPrice} /></RedPriceTooltip> : <>{flat?.redPrice ? <div className={styles.flatDescription__price}><p className={styles.flatDescription__amount}><span>{formatLongPrice(flat?.currentPrice)} <span>₽</span></span><><Svg src={infoIcon?.src} data-tooltip-id="duty" className={styles.icon} /><Tooltip id="duty" place="top" openEvents={{
              click: isMobile,
              mouseenter: !isMobile
            }} closeEvents={{
              click: isMobile,
              mouseleave: !isMobile
            }} className={styles.tooltip} classNameArrow={styles.tooltipArrow}><span>Только при 100% оплате или ипотеке без субсидирования</span></Tooltip></></p><meta itemProp="price" content={flat?.currentPrice} /><div className={styles.flatDescription__discount}><p className={styles.flatDescription__discount__text}>{formatLongPrice(flat?.real_price)} <span>₽</span></p></div></div> : <>{flat?.currentPrice > 1 ? <div className={styles.flatDescription__price}><p className={styles.flatDescription__amount}>{formatLongPrice(getFlatPrice())} <span>₽</span></p><meta itemProp="price" content={getFlatPrice()} />{selectedBenefit?.bestPrice && <div className={styles.flatDescription__discount}><p className={styles.flatDescription__discount__text}>{formatLongPrice(flat?.real_price)} <span>₽</span></p></div>}</div> : <span className={styles.flatDescription__discount__text}>По запросу</span>}</>}</>;
    $[5] = flat?.currentPrice;
    $[6] = flat?.promo;
    $[7] = flat?.real_price;
    $[8] = flat?.redPrice;
    $[9] = getFlatPrice;
    $[10] = isMobile;
    $[11] = selectedBenefit?.bestPrice;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <meta itemProp="priceCurrency" content="RUB" />;
    t4 = <link itemProp="availability" href={SCHEMA.IN_STOCK} />;
    $[13] = t3;
    $[14] = t4;
  } else {
    t3 = $[13];
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t2) {
    t5 = <div className={styles.flatInfoRight__priceBlock} itemProp="offers" itemScope={true} itemType={SCHEMA.OFFER}>{t2}{t3}{t4}</div>;
    $[15] = t2;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default PriceBlock;
function _temp(state) {
  return state?.equalizer;
}